<template>
  <section>
    <div v-if="shopifyData.secLink == ' '">
      <div class="grid_container">
        <div v-for="(image, index) in shopifyData.box" :key="index">
          <a :href="image.imageLink" aria-label="Image Link">
            <img
              v-lazy="image.image"
              :alt="image.imagealt"
              loading="lazy"
              aria-label="Image"
              width=""
              height=""
            />
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <a :href="shopifyData.secLink">
        <div class="grid_container">
          <div v-for="(image, index) in shopifyData.box" :key="index">
            <a :href="image.imageLink" aria-label="Image Link">
              <img
                v-lazy="image.image"
                :alt="image.imagealt"
                loading="lazy"
                aria-label="Image"
                width=""
                height=""
              />
            </a>
          </div>
        </div>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    // console.log('Received shopifyData:', this.shopifyData);
  },
};
</script>

<style scoped>
.grid_container {
  display: grid;
  grid-template-columns: repeat(3, auto);
}
a {
  display: block;
}
.grid_container img {
  display: block;
}
</style>
